import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
    <div>
      <footer>
        Code by Rusanne Visagie
        <a href="https://github.com/Roz18/weathershouldi"> GitHub</a>
      </footer>
    </div>
  </React.StrictMode>
);

reportWebVitals();
